import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';
import { ErrorPage } from '@tasama/ui';
import { PORTAL_ROUTES } from '@tasama/config';

/**
 * Thin React Router wrapper around ErrorPage for the portal app.
 * Used as the `errorElement` on the pathless root route in router.tsx.
 *
 * Resolves the error variant from React Router's useRouteError() hook so
 * that ErrorPage itself stays decoupled from any routing library.
 */
export const AppErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const variant =
    isRouteErrorResponse(error) && error.status === 404 ? 'not-found' : 'error';

  return (
    <ErrorPage
      variant={variant}
      testID="portal-route-error"
      onHomeClick={() => navigate(PORTAL_ROUTES.HOME)}
      onBackClick={() => navigate(-1)}
      onReloadClick={() => window.location.reload()}
    />
  );
};

AppErrorPage.displayName = 'AppErrorPage';
